// 鼎 rank marks — each 科舉 rank wears a real bronze vessel, sourced from
// The Met Open Access (CC0 / public domain) and cropped to a medallion.
// 鼎甲 — the top three (狀元/榜眼/探花) carry authentic Shang–Zhou ritual 鼎.
// See public/assets/ding/CREDITS.md for object IDs and licence.
// 狀元 商饕餮鼎 · 榜眼 周蓋鼎 · 探花 周扁足鼎 · 傳臚 明鎏金鼎爐 · 進士 元素鼎爐

const VESSELS = ["商饕餮鼎", "周蓋鼎", "周扁足鼎", "明鎏金鼎爐", "元銅鼎爐"];

export function DingMark({ rank }: { rank: number }) {
  const tier = Math.min(Math.max(rank, 0), VESSELS.length - 1);
  return (
    <img
      className="ding"
      src={`/assets/ding/m${tier + 1}.webp`}
      alt={VESSELS[tier]}
      width={40}
      height={40}
      loading="lazy"
      decoding="async"
      draggable={false}
    />
  );
}
